import { Modal, DateDisplay, CodeDisplay } from "@aidkitorg/component-library"
import { useLocalizedStrings } from "../../../Localization";
import { AuditLogModalProps } from "../types";
import { formatJsonValue } from "../utils";

const ModalDataBlock = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div>
    <h6 className="font-semibold mb-2">{title}</h6>
    <div className="opacity-80 bg-gray-100 text-black p-2 rounded">
      {children}
    </div>
  </div>
);

export const AuditLogModal = ({ auditLog, isOpen, onClose }: AuditLogModalProps) => {
  const L = useLocalizedStrings();

  return (
    <Modal open={isOpen} onClose={onClose} title="Audit Log Details" size="lg" titleSize="h2">
      {auditLog && (
        <div className="flex flex-col gap-4 mt-4 break-words">
          <ModalDataBlock title={L.admin_panel.audit_logs.event}>{auditLog.event}</ModalDataBlock>
          <ModalDataBlock title={L.admin_panel.audit_logs.timestamp}>
            <DateDisplay className="text-md" utcValue={auditLog.timestamp} />
          </ModalDataBlock>
          <ModalDataBlock title={L.admin_panel.audit_logs.user}>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <div className="font-semibold">{L.admin_panel.audit_logs.name}</div>
                <span className="break-words">{auditLog.userName}</span>
              </div>
              <div>
                <div className="font-semibold">{L.admin_panel.audit_logs.uid}</div>
                <span className="break-words">{auditLog.uid}</span>
              </div>
              <div>
                <div className="font-semibold">{L.admin_panel.audit_logs.email}</div>
                <span className="break-words">{auditLog.userEmail}</span>
              </div>
            </div>
          </ModalDataBlock>
          <ModalDataBlock title={L.admin_panel.audit_logs.metadata}>
            <CodeDisplay
              code={formatJsonValue(auditLog.value)}
              language="json"
              showLineNumbers={false}
              copyable={false}
              expandable={true}
              variant="gray"
            />
          </ModalDataBlock>
        </div>
      )}
    </Modal>
  );
};
